module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/components/QualificationItemList/asset/grab.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/components/QualificationItemList/asset/grab.png
// module id = 824
// module chunks = 431